import { render, staticRenderFns } from "./CountryEdit.vue?vue&type=template&id=1e985fc3&"
import script from "./CountryEdit.vue?vue&type=script&lang=js&"
export * from "./CountryEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports